import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BidService} from '../../services/bid.service';
import {AlertService} from '../../services/alert.service';
import {LoadingController} from '@ionic/angular';
import {StorageService} from '../../services/storage.service';

@Component({
  selector: 'app-bandeja-contratos',
  templateUrl: './bandeja-contratos.page.html',
  styleUrls: ['./bandeja-contratos.page.scss'],
})
export class BandejaContratosPage implements OnInit {

  lstContract;

  constructor(private router: Router, private bidService: BidService,
              private alertService: AlertService,
              private loadingController: LoadingController,
              private  storageService: StorageService) {
    this.getContracts();
  }

  ngOnInit() {
  }

  nextPage(contract: any) {

    console.log("adasdad");
    if ((contract.identificationType === 'PASAPORTE' || contract.identificationType === 'CEDULA PROFESIONAL') && contract.isNewDevice) {

      this.alertService.presentAlert('Error', 'No se puede continuar con la orden debido a que es una venta con equipo y el enrolamiento se realizó con una identificación no válida para este tipo de venta').then();
    } else {

      console.log("ASDdassaddasd");
      console.log("ASDdassaddasd");
      console.log("ASDdassaddasd");
      console.log("ASDdassaddasd");
      console.log("ASDdassaddasd");

      this.loadingController.getTop().then(hasLoading => {
        this.loadingController.create({
          spinner: 'circular',
          translucent: true
        }).then(loading => loading.present());
      });

      console.log("ASDdassaddasd");
      console.log(contract);
      const request = {
        operationId: contract.operationId,
        orderId: contract.orderId,
        email: contract.email,
        name: contract.name
      };


      this.bidService.createOrder(contract.orderId , request).subscribe(data => {

        this.storageService.saveToStorage('orderId', contract.orderId).then();
        this.storageService.saveToStorage('operationIdOTP', contract.operationId).then();
        this.router.navigateByUrl('otp').then();
        this.loadingController.dismiss().then();

      }, () => {
        this.loadingController.dismiss().then();
      });
    }


  }

  refresh(){
    this.getContracts();
  }
  getContracts() {

    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });
    this.bidService.getPendingOrders().subscribe(data => {
      this.lstContract = data;
      console.log(data);
      this.loadingController.dismiss().then();
      ;
    }, () => {
      this.loadingController.dismiss().then();
    });
  }

}
